// @flow

// Vendor
import React from 'react';

// Types
type Props = {
  label: String,
  onClick: Function
};

const LoadMore = ({ label, onClick }: Props) => (
  <section className="section section--sm">
    <div className="container">
      <div className="load-more">
        <div className="grid grid--center">
          <div className="grid__col-xs-12 grid__col-sm-8 grid__col-md-6 grid__col-lg-4">
            <button className="btn btn--primary btn--block" onClick={onClick}>
              {label}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LoadMore;
